import React from "react";
import Logo from '../assets/svg/logo.svg';

export default function PrivacyPolicy() {
  return (
    <>
      <a href="/" className="logo" style={{ margin: 20, top: 10, position: 'fixed' }}>
        <img src={Logo} alt="Logo" />
      </a>
  <div className="privacy-policy-content" style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
    <h1 style={{ textAlign: "center", marginBottom: 32 }}>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h1>
      <p><b>Дата вступления в силу:</b> [дата]</p>
      <p>
        Настоящая политика конфиденциальности, размещенная по ссылке [ссылка]
        (далее – «Политика») определяет порядок обработки и защиты персональных
        данных оператором ООО «Жива Технологии» (ОГРН: 1257700121800, ИНН:
        9723250048, юридический адрес: 109390, город Москва, ул. Люблинская, д. 47,
        помещ. 2/н) в отношении субъектов персональных данных – пользователей сайта
        «Jiva», который размещен в сети Интернет по адресу <a href="https://jivatech.ru/" target="_blank" rel="noopener noreferrer">https://jivatech.ru/</a>.
      </p>
      <p>
        Использование Сайта, включая любые его функции, означает согласие
        Пользователя с условиями Политики. Если Пользователь не согласен с условия
        Политики и не готов их принять, он обязан воздержаться от использования Сайта.
      </p>

      <h2>1. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</h2>
      <ul>
        <li>
          <b>Сайт</b> – совокупность данных и иной информации под названием «Jiva»,
          доступные для просмотра в сети Интернет по адресу <a href="https://jivatech.ru/" target="_blank" rel="noopener noreferrer">https://jivatech.ru/</a> и его
          поддоменах.
        </li>
        <li>
          <b>Персональные данные</b> – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных);
        </li>
        <li>
          <b>Оператор</b> – Общество с ограниченной ответственностью «Жива
          Технологии» (ОГРН: 1257700121800, ИНН: 9723250048, юридический адрес:
          109390, город Москва, ул. Люблинская, д. 47, помещ. 2/н), самостоятельно
          или совместно с другими лицами, организующее и (или) осуществляющее
          обработку персональных данных, а также определяющее цели обработки
          персональных данных, состав персональных данных, подлежащих
          обработке, действия (операции), совершаемые с персональными данными;
        </li>
        <li>
          <b>Пользователь</b> – физическое лицо, достигшее возраста 14 лет,
          использующее Сайт и являющееся субъектом персональных данных;
        </li>
        <li>
          <b>Обработка Персональных данных</b> – любое действие (операция) или
          совокупность действий (операций), совершаемых с использованием средств
          автоматизации или без использования таких средств с персональными
          данными, включая сбор, запись, систематизацию, накопление, хранение,
          уточнение (обновление, изменение), извлечение, использование, передачу
          (распространение, предоставление, доступ), обезличивание, блокирование,
          удаление, уничтожение персональных данных;
        </li>
        <li>
          <b>Автоматизированная обработка Персональных данных</b> – обработка
          персональных данных с помощью средств вычислительной техники;
        </li>
        <li>
          <b>Предоставление Персональных данных</b> – действия, направленные на
          раскрытие персональных данных определенному лицу или определенному
          кругу лиц;
        </li>
        <li>
          <b>Блокирование Персональных данных</b> – временное прекращение
          обработки персональных данных (за исключением случаев, если обработка
          необходима для уточнения персональных данных);
        </li>
        <li>
          <b>Уничтожение Персональных данных</b> – действия, в результате которых
          становится невозможным восстановить содержание персональных данных в
          информационной системе персональных данных и (или) в результате
          которых уничтожаются материальные носители персональных данных;
        </li>
        <li>
          <b>Трансграничная передача персональных данных</b> – передача
          персональных данных на территорию иностранного государства органу
          власти иностранного государства, иностранному физическому лицу или
          иностранному юридическому лицу.
        </li>
        <li>
          <b>Cookies</b> – фрагмент данных, отправленный веб-сервером и хранимый на
          компьютере пользователя, который веб-клиент или веб-браузер каждый раз
          пересылает веб-серверу в HTTP-запросе при попытке открыть страницу
          Сайта.
        </li>
        <li>
          <b>IP-адрес</b> – означает уникальный сетевой адрес узла в компьютерной сети,
          через который Пользователь получает доступ к Сайту.
        </li>
      </ul>

      <h2>2. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
      <p>
        2.1 2.2 2.3 Целью настоящей Политики является обеспечение защиты прав и свобод
        человека и гражданина при обработке его персональных данных, в том числе
        защиты прав на неприкосновенность частной жизни, личную и семейную
        тайну.
      </p>
      <p>
        Политика конфиденциальности разработана в соответствии с Федеральным
        законом от 27.07.2006 № 152-ФЗ «О персональных данных» и иными
        нормативными правовыми актами Российской Федерации в области защиты
        персональных данных.
      </p>
      <p>
        Правовым обоснованием обработки Персональных данных являются:
      </p>
      <ul>
        <li>согласие Пользователя на обработку его персональных данных,
          полученное в специально установленной форме при переходе на Сайт;
        </li>
        <li>необходимость обработки Персональных данных в целях исполнения
          условий Пользовательского соглашения, являющегося неотъемлемой
          частью Политики конфиденциальности и стороной которого является
          Пользователь;
        </li>
      </ul>
      <p>
        2.4 Оператор осуществляет обработку Персональных данных, руководствуясь
        следующими принципами:
      </p>
      <ul>
        <li>законность и справедливая основа обработки;</li>
        <li>обработка в соответствии с конкретными, заранее определенным и
          законными целями;
        </li>
        <li>недопущение избыточности обработки;</li>
        <li>обеспечение точности, достаточности и актуальности Персональных
          данных;
        </li>
        <li>хранение Персональных данных не дольше, чем этого требуют цели
          обработки;
        </li>
        <li>обеспечение конфиденциальности и безопасности Персональных данных.</li>
      </ul>

      <h2>3. ОБЪЕМ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
      <p>
        3.1. Оператор осуществляет обработку Персональных данных в следующем объеме:
      </p>
      <ul>
        <li>файлы cookies и pixels;</li>
        <li>технические данные: IP-адрес, тип устройства, операционная система, идентификаторы устройства, данные об использовании Сайта;</li>
        <li>данные, предоставленные Google Analytics и Yandex Metrika (при переходе на Сайт с использованием поисковой системы);</li>
      </ul>
      <p>
        3.2. На Сайте используются cookies и pixels (IP адрес; информация из cookies, информация о браузере, время доступа к сайту, адрес страницы, на которой расположен рекламный блок, referer (адрес предыдущей страницы) и другие данные).
      </p>
      <p>
        3.3. При помощи этих данных собирается информация о действиях Пользователей на Сайте с целью улучшения его содержания, улучшения функциональных возможностей и удобства для Пользователей Сайта, Программного продукта Оператора.
      </p>
      <p>
        3.4. Пользователь может в любой момент изменить настройки своего браузера так, чтобы все файлы cookie блокировались или осуществлялось оповещение об их отправке. При этом Пользователь должен понимать, что некоторые функции и сервисы Сайта не смогут работать должным образом.
      </p>
      <p>
        3.5. Оператором используются сервисы аналитики (Google Analytics и Yandex Metrika) для предоставления соответствующего содержимого Платформы, для измерения и (или) понимания эффективности рекламы Оператора, улучшения услуг Оператора и персонализации опыта Пользователей о взаимодействии с возможностями Программного продукта, функционалом Сайта и деятельностью Оператора.
      </p>

      <h2>4. ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
      <ul>
        <li>обеспечения надлежащей работоспособности Сайта;</li>
        <li>выявление и устранение ошибок;</li>
        <li>обеспечения безопасной и стабильной работы Сайта;</li>
        <li>статистического анализа использования Сайта.</li>
      </ul>
      <p>
        4.2. Оператор не осуществляет обработку биометрических персональных данных Пользователя, специальных категорий персональных данных Пользователя.
      </p>

      <h2>5. ПОРЯДОК ПОЛУЧЕНИЯ СОГЛАСИЯ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
      <p>
        5.1. При переходе на Сайт Пользователь предупреждается об использовании об обработке персональных данных в соответствующем модальном окне: «Продолжая использовать Сайт и/или нажимая на кнопку «Принять все», вы соглашаетесь, что на сайте обрабатываются персональные данные пользователя сайта: cookies и pixels; технические данные: IP-адрес, тип устройства, операционная система, идентификаторы устройства, данные об использовании Сайта; данные, предоставленные Google Analytics и Yandex Metrika (при переходе на Сайт с использованием поисковой системы).». Пользователь может настроить перечень обрабатываемых персональных данных (нажать кнопку «Настроить»), либо же отказаться от обработки всех персональных данных, за исключением тех, которые необходимы для функционирования Сайта по назначению.
      </p>
      <p>
        5.2. Игнорирование Пользователем модального окна с согласием на обработку персональных данных и продолжение использования Сайта является согласием Пользователя на обработку персональных данных, обрабатываемых по умолчанию.
      </p>
      <p>
        5.3. При предоставлении Оператору Персональных данных третьих лиц, в частности, при использовании устройств, принадлежащих третьим лицам, Пользователь заверяет и гарантирует, что:
      </p>
      <ul>
        <li>а) получил Персональные данные законными способами;</li>
        <li>б) обладает законными основаниями обработки Персональных данных (в том числе согласием субъектов Персональных данных на передачу Персональных данных Оператору с целью хранения);</li>
        <li>в) соблюдает принципы и правила обработки Персональных данных, предусмотренные законодательством Российской Федерации.</li>
      </ul>

      <h2>6. ПОРЯДОК И УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
      <p>
        6.1 Оператор осуществляет обработку Персональных данных Пользователя с использованием средств автоматизации и без использования таких средств.
      </p>
      <p>
        6.2 Обработка Персональных данных включает в себя следующие действия: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ) третьим лицам (в случаях, предусмотренных настоящей Политикой и законодательством РФ), обезличивание, блокирование, удаление, уничтожение.
      </p>
      <p>
        6.3 Обработка персональных данных осуществляется на основании согласия Пользователя в соответствии с разделом 5 настоящей Политики.
      </p>
      <p>
        6.4 Срок обработки Персональных данных определяется достижением целей обработки, если иное не предусмотрено законодательством РФ или настоящей Политикой. Пользователь вправе отозвать свое согласие на обработку Персональных данных, что, в свою очередь, влечет обязательство Пользователя прекратить любое использование Сайта.
      </p>
      <p>
        6.5 Оператор вправе передавать Персональные данные Пользователя следующим третьим лицам:
      </p>
      <ul>
        <li>а) поставщикам услуг, обеспечивающим функционирование Сайта (хостинг-провайдеры, платежные системы (в части данных, необходимых для оплаты Premium подписки));</li>
        <li>б) финансовым организациям, осуществляющим обработку платежей за предоставление Premium подписки;</li>
        <li>в) государственным органам в случаях, предусмотренных законодательством РФ;</li>
        <li>г) иным лицам в случаях, прямо предусмотренных законом.</li>
      </ul>
      <p>
        6.6 При передаче Персональных данных третьим лицам Оператор обеспечивает соблюдение требований конфиденциальности и безопасности Персональных данных.
      </p>
      <p>
        6.7 Оператор не осуществляет трансграничную передачу Персональных данных Пользователя.
      </p>
      <p>
        6.8 Пользователь заверяет Оператора, что является гражданином Российской Федерации, и обработка его Персональных данных не затрагивает применение норм зарубежного законодательства в сфере регулирования персональных данных и не создает для Оператора иных обязательств, кроме предусмотренных Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и другими нормативными правовыми актами РФ в сфере обработки персональных данных.
      </p>

      <h2>7. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
      <ul>
        <li>получать информацию, касающуюся обработки его Персональных данных;</li>
        <li>требовать уточнения своих Персональных данных, их блокирования или уничтожения в случае, если Персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленных Оператором целей обработки;</li>
        <li>отозвать свое согласие на обработку Персональных данных;</li>
        <li>обжаловать действия или бездействие Оператора в уполномоченный орган государственной власти по защите прав субъектов персональных данных или в судебном порядке;</li>
        <li>иные действия, предусмотренные действующим законодательством РФ.</li>
      </ul>
      <p>
        7.2. Для реализации своих прав Пользователь вправе обратиться к Оператору с запросом, направив его по адресу электронной почты: <a href="mailto:info@jivatech.ru">info@jivatech.ru</a>.
      </p>
      <p>
        7.3. Запрос Пользователя, направляемый в соответствии с п. 7.2 Политики должен содержать следующую информацию:
      </p>
      <ul>
        <li>сведения, позволяющие идентифицировать Пользователя (ФИО, эл. почта);</li>
        <li>информацию о запрашиваемых сведениях/требованиях;</li>
        <li>подпись Пользователя.</li>
      </ul>
      <p>
        7.4. Оператор обязан предоставить ответ на запрос Пользователя в течение 10 (десяти) рабочих дней с момента получения соответствующего запроса. Оператор вправе запрашивать у Пользователя дополнительную информацию, необходимую для предоставления ответа или удовлетворения требований Пользователя.
      </p>
      <ul>
        <li>обеспечивать конфиденциальность и безопасность Персональных данных при их обработке;</li>
        <li>принимать необходимые правовые, организационные и технические меры для защиты Персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, копирования, предоставления, распространения, а также от иных неправомерных действий в отношении Персональных данных;</li>
        <li>предоставлять Пользователю информацию об обработке его Персональных данных по соответствующим запросам;</li>
        <li>уточнять, блокировать или уничтожать Персональные данные по требованию Пользователя в случаях, предусмотренных законодательством РФ;</li>
        <li>прекратить обработку Персональных данных в случае отзыва Пользователем согласия на обработку, если отсутствуют иные законные основания для обработки;</li>
        <li>уведомлять уполномоченный орган (Роскомнадзор) об утечках персональных данных в установленном порядке;</li>
        <li>исполнять иные обязанности, предусмотренные законодательством РФ.</li>
      </ul>

      <h2>8. МЕРЫ ПО ОБЕСПЕЧЕНИЮ БЕЗОПАСНОСТИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
      <p>
        8.1 Оператор принимает все необходимые и достаточные правовые, организационные и технические меры для защиты Персональных данных Пользователя от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий.
      </p>
      <p>
        8.2 К мерам, указанным в п. 8.1, в частности, относятся:
      </p>
      <ul>
        <li>назначение лица, ответственного за организацию обработки Персональных данных;</li>
        <li>издание локальных актов по вопросам обработки Персональных данных;</li>
        <li>ознакомление работников Оператора, непосредственно осуществляющих обработку Персональных данных, с положениями законодательства РФ о персональных данных, в том числе с требованиями к защите персональных данных, локальными актами по вопросам обработки Персональных данных;</li>
        <li>применение организационных и технических мер по обеспечению безопасности Персональных данных при их обработке в информационных системах, необходимых для выполнения требований к защите персональных данных (в соответствии с требованиями Постановления Правительства РФ от 01.11.2012 N 1119 "Об утверждении требований к защите персональных данных при их обработке в информационных системах персональных данных" и Приказа ФСТЭК России от 18.02.2013 N 21 "Об утверждении Состава и содержания организационных и технических мер по обеспечению безопасности персональных данных при их обработке в информационных системах персональных данных");</li>
        <li>оценка вреда, который может быть причинен субъектам персональных данных в случае нарушения положений законодательства;</li>
        <li>определение угроз безопасности Персональных данных при их обработке в информационных системах;</li>
        <li>применение средств защиты информации, прошедших в установленном порядке процедуру оценки соответствия;</li>
        <li>учет машинных носителей Персональных данных;</li>
        <li>обеспечение физической безопасности помещений, в которых размещены информационные системы;</li>
        <li>разграничение доступа к Персональным данным и использование парольной защиты;</li>
        <li>резервное копирование Персональных данных;</li>
        <li>контроль за принимаемыми мерами по обеспечению безопасности Персональных данных и уровня защищенности информационных систем;</li>
        <li>обнаружение фактов несанкционированного доступа к Персональным данным и принятие мер по устранению возникшей угрозы.</li>
      </ul>

      <h2>9. ПОРЯДОК ПРЕКРАЩЕНИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
      <p>
        9.1 В случае отзыва Пользователем согласия на обработку персональных данных, Оператор прекращает их обработку и уничтожает данные в срок, не превышающий 30 (тридцати) дней с даты поступления отзыва, если отсутствуют иные законные основания для обработки.
      </p>
      <p>
        9.2 Пользователь может прекратить сбор персональных данных, воспользовавшись функционалом Сайта (за исключением персональных данных, необходимых для функционирования Сайта по назначению).
      </p>

      <h2>10. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h2>
      <p>
        10.1 Настоящая Политика может быть изменена Оператором в одностороннем порядке. Новая редакция Политики вступает в силу с момента ее размещения на Сайте, если иное не предусмотрено новой редакцией Политики.
      </p>
      <p>
        10.2 Уведомление Пользователя об изменении Политики осуществляется путем размещения новой редакции Политики на Сайте.
      </p>
      <p>
        10.3 Все вопросы, не урегулированные настоящей Политикой, регулируются законодательством Российской Федерации.
      </p>
      <p>
        10.4 Ответственным лицом Оператора, осуществляющим непосредственную обработку и контроль за Персональными данными, является Генеральный директор Сметанев Данил Михайлович.
      </p>
      <p>
        10.5 По любым вопросам Пользователя касательно обработки персональных данных, Политики, либо в случае необходимости реализовать предоставленные Пользователю как субъекту персональных данных права, Пользователь вправе обратиться по адресу электронной почты <a href="mailto:info@jivatech.ru">info@jivatech.ru</a>.
      </p>
      <p>
        10.6 Контактная информация Оператора:<br/>
        ООО «Жива Технологии»,<br/>
        ОГРН: 1257700121800, ИНН: 9723250048<br/>
        Юридический адрес: 109390, город Москва, ул. Люблинская, д. 47, помещ. 2/н<br/>
        Email: <a href="mailto:info@jivatech.ru">info@jivatech.ru</a>
      </p>
    </div>
    </>
  );
}
